import React, { ChangeEvent } from 'react';
import { Stack } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import 'dayjs/locale/es';
import { FormikTouched } from 'formik/dist/types';
import { DateValidationError } from '@mui/x-date-pickers/models';
import { PickerChangeHandlerContext } from '@mui/x-date-pickers/internals/hooks/usePicker/usePickerValue.types';

type Props = {
    label: string;
    name: string;
    size?: undefined | 'small' | 'medium';
    margin?: 'dense' | 'normal' | 'none';
    required?: false | boolean;
    value?: any;
    touched?: boolean | FormikTouched<any> | FormikTouched<any>[] | undefined;
    errors?: any;
    minDate?: any;
    maxDate?: any;
    disabled?: boolean;
    disablePast?: boolean;
    disableFuture?: boolean;
    onChange: (
        value: ChangeEvent<HTMLInputElement> | null,
        context: PickerChangeHandlerContext<DateValidationError>
    ) => void;
};

const DatePickerField = ({
    label,
    name,
    touched,
    errors,
    minDate = undefined,
    maxDate = undefined,
    disabled,
    disablePast = false,
    disableFuture = false,
    onChange,
    required,
    size,
    value,
}: Props) => {
    //onChange Formik
    //The variable timeVariableFormik must be equal to the variable name of the formik
    //onChange={(value) => formik.setFieldValue('dateVariableFormik', value, true)}

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
            <Stack component="div">
                <DatePicker
                    label={label}
                    value={value || null}
                    disabled={disabled}
                    disablePast={disablePast}
                    minDate={minDate}
                    maxDate={maxDate}
                    disableFuture={disableFuture}
                    onChange={onChange}
                    slotProps={{
                        textField: {
                            name: name,
                            size: size,
                            required: required,
                            error: touched && Boolean(errors),
                            helperText: touched ? errors : '',
                        },
                    }}
                />
            </Stack>
        </LocalizationProvider>
    );
};

export default DatePickerField;
